import { selectChangeMessageForHtmlString } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForHtmlString';
import type { EditAsideAttachedContent } from '@nodeTypeConfig/configTypes';

export const attachedContentComponent: EditAsideAttachedContent = {
  component: 'attachedContent',
  label: 'Inhoud',
  property: '$$html',
  reactComponent: 'AsideAttachedContent',
  asideChangeMessageSelector: selectChangeMessageForHtmlString,
};
